var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h5DeviceWrap"},[(_vm.token && _vm.no)?_c('Live',{attrs:{"isWebview":true}}):_c('pageToast',{attrs:{"msg":_vm.msg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }